import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Container, btn } from "@/components/ui-kit";
import { COMPANY } from "@/lib/content";
import { ArrowRight, House } from "@phosphor-icons/react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <Seo title="Page Not Found" description="The page you're looking for could not be found." path="/404" />
      <section className="relative bg-forest text-white min-h-[72vh] flex items-center overflow-hidden">
        <div className="grain" />
        <Container className="relative py-24 text-center">
          <span className="font-serif text-7xl sm:text-8xl font-semibold text-gold/30 select-none">404</span>
          <h1 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
            This page couldn't be found
          </h1>
          <p className="mt-5 text-white/70 text-lg leading-relaxed max-w-xl mx-auto">
            The page you're looking for may have moved. Let's get you back to a strong starting point.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/" className={btn.gold} data-testid="notfound-home-btn">
              <House size={18} /> Back to Home
            </Link>
            <Link to="/submit-property" className={btn.outlineLight} data-testid="notfound-submit-btn">
              Submit a Property <ArrowRight size={18} />
            </Link>
          </div>
          <p className="mt-10 text-white/40 text-sm">
            {COMPANY.name} · {COMPANY.location}
          </p>
        </Container>
      </section>
    </div>
  );
}
